import { IntervenerTypes } from "../enums/backend.enums";

export interface IntervenerModel {
    id: number;
    appraiserId?: number;
    firstName: string;
    lastName: string;
    intervenerType: IntervenerTypes;
    nationalIdentityDocument: string;
    canEdit: boolean;
    canDelete: boolean;
}